import { getOverrideTranslation } from '@ps/web-shared-components';
import type { TranslationTag } from '@ps/web-shared-components';
import { useCallback } from 'react';
import type { IntlFormatters } from 'react-intl';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { select } from '../store';

export const useRegulatoryIntl = () => {
  const { formatMessage: intlFormatMessage } = useIntl();

  const showVegasContent = useSelector(select.cms.showVegasContent);
  const showOntarioContent = useSelector(select.cms.showOntarioContent);

  const formatMessage = useCallback<IntlFormatters<React.ReactNode>['formatMessage']>(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- the consumer will receive the argument types from intlFormatMessage
    (descriptor: TranslationTag, ...restArgs: any[]) =>
      intlFormatMessage(
        {
          ...descriptor,
          ...getOverrideTranslation({
            vegas: descriptor.vegas,
            ontario: descriptor.ontario,
            showVegasContent,
            showOntarioContent
          })
        },
        ...restArgs
      ),
    [intlFormatMessage, showOntarioContent, showVegasContent]
  );

  return { formatMessage };
};
